import { connect } from "react-redux";
import { langugae } from "../../config/languageJSON";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import ProductWiseSkuPdfHeader from "../Common/ProductWiseSkuPdf/components/ProductWiseSkuPdfHeader";
import ProductWiseSkuPdfTable from "../Common/ProductWiseSkuPdf/components/ProductWiseSkuPdfTable";
import { useProductWiseSkuPdfData } from "../Common/ProductWiseSkuPdf/hooks/useProductWiseSkuPdfData";
import {
  pageWrap,
  tableWrap,
} from "../Common/ProductWiseSkuPdf/styles/productWiseSkuPdfStyles";
import {
  getPdfDateRange,
  getSkuPdfLists,
} from "../Common/ProductWiseSkuPdf/utils/productWiseSkuPdfUtils";
import { fetchLoadSheetSkuWise } from "./LoadSheetProductWise/utils/loadSheetProductWiseApi";
import {
  getLoadSheetProductAllQty,
  getLoadSheetUomQty,
} from "./LoadSheetProductWise/utils/loadSheetQtyUtils";
import "./billPDFCss.css";

// Billing History — SKU-wise load sheet print page.
const LoadSheetProductWisePDF = ({ showLoador, showNotification }) => {
  const { billList } = useProductWiseSkuPdfData({
    showLoador,
    showNotification,
    fetchData: fetchLoadSheetSkuWise,
  });

  if (Object.keys(billList).length == 0) {
    return null;
  }

  const { dateLabel } = getPdfDateRange();
  const { categoryWithProducts, uomList, orderSummaries } =
    getSkuPdfLists(billList);

  return (
    <>
      <div style={pageWrap}>
        <ProductWiseSkuPdfHeader
          title={
            langugae[2].billDispatch ? langugae[2].billDispatch : ""
          }
          billList={billList}
          dateLabel={dateLabel}
          showBeatName={true}
        />

        <div style={tableWrap}>
          <ProductWiseSkuPdfTable
            billList={billList}
            dateLabel={dateLabel}
            categoryWithProducts={categoryWithProducts}
            uomList={uomList}
            orderSummaries={orderSummaries}
            getUomQty={getLoadSheetUomQty}
            getProductAllQty={getLoadSheetProductAllQty}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadSheetProductWisePDF);
